import enCommon from "../translations/en/common.json";
import enHome from "../translations/en/home.json";
import enProjects from "../translations/en/projects.json";
import enServices from "../translations/en/services.json";
import enPrices from "../translations/en/prices.json";
import enContact from "../translations/en/contact.json";
import enAbout from "../translations/en/about.json";
import deCommon from "../translations/de/common.json";
import deHome from "../translations/de/home.json";
import deProjects from "../translations/de/projects.json";
import deServices from "../translations/de/services.json";
import dePrices from "../translations/de/prices.json";
import deContact from "../translations/de/contact.json";
import deAbout from "../translations/de/about.json";
import roCommon from "../translations/ro/common.json";
import roHome from "../translations/ro/home.json";
import roProjects from "../translations/ro/projects.json";
import roServices from "../translations/ro/services.json";
import roPrices from "../translations/ro/prices.json";
import roContact from "../translations/ro/contact.json";
import roAbout from "../translations/ro/about.json";

export const translations = {
  en: {
    common: enCommon,
    home: enHome,
    projects: enProjects,
    services: enServices,
    prices: enPrices,
    contact: enContact,
    about: enAbout,
  },
  de: {
    common: deCommon,
    home: deHome,
    projects: deProjects,
    services: deServices,
    prices: dePrices,
    contact: deContact,
    about: deAbout,
  },
  ro: {
    common: roCommon,
    home: roHome,
    projects: roProjects,
    services: roServices,
    prices: roPrices,
    contact: roContact,
    about: roAbout,
  },
};
